<template>
    <div>
        <div class="fixed bottom-0 left-0 w-screen z-50">
            <div class="relative py-2" :class="{ 'bg-white h-full': activeIndex === -1 }" :style="topWrapperStyle">
                <ul class="relative w-full flex z-20" ref="menuWrapper">
                    <li v-for="(item, index) in list" :key="index" class="flex-1 flex justify-center">
                        <UChip
                            size="lg"
                            :text="item.chip"
                            :show="!isUndefined(item.chip) && item.chip !== 0"
                            :ui="{ size: { lg: 'p-1 pt-1.5' } }"
                            class="flex flex-col justify-center items-center gap-1 text-gray-500 cursor-pointer list-menu-item"
                            :class="{
                                'bg-amazon-500 rounded-full active-menu-item -translate-y-1/2 aspect-square':
                                    item.active,
                            }"
                            @click="item.action"
                        >
                            <UIcon
                                :name="item.icon"
                                :class="item.active ? 'w-8 h-8 text-white relative z-10' : 'w-6 h-6'"
                            />
                            <UiComponentTypography
                                v-if="!item.active"
                                variant="subtitle2"
                                class-name="whitespace-nowrap text-[.65rem]"
                            >
                                {{ item.label }}
                            </UiComponentTypography>
                        </UChip>
                    </li>
                </ul>
                <div class="absolute w-full top-0 left-0 z-10 flex items-end h-[var(--wrapper-height)]">
                    <div
                        class="before-gap bg-white"
                        :class="activeIndex === -1 ? '' : 'shadow-58'"
                        :style="beforeGapStyle"
                    ></div>
                    <div
                        class="middle-gap relative h-full before:absolute after:absolute"
                        :style="middleGapStyle"
                    ></div>
                    <div
                        class="after-gap bg-white"
                        :class="activeIndex === -1 ? '' : 'shadow-58'"
                        :style="afterGapStyle"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
interface IMenuItem {
    label: string;
    icon: string;
    action: () => void;
    active?: boolean;
    chip?: string | number;
}

const route = useRoute();

const menuWrapper = ref<HTMLElement | null>(null);

const { width: wrapperWidth, height: wrapperHeight } = useElementBounding(menuWrapper);
const { data: cart } = useCart();

const list = computed<IMenuItem[]>(() => [
    {
        label: "خانه",
        icon: "i-solar-home-angle-linear",
        active: route.path === "/",
        action: () => {
            navigateTo("/");
        },
    },
    {
        label: "محصولات",
        icon: "i-solar-widget-line-duotone",
        active: route.path.includes("/category"),
        action: () => {
            navigateTo("/category");
        },
    },
    {
        label: "جستجو",
        icon: "i-solar-minimalistic-magnifer-line-duotone",
        active: route.path.includes("/search"),
        action: () => {
            navigateTo("/search");
        },
    },
    {
        label: "سبد خرید",
        icon: "i-solar-cart-5-line-duotone",
        active: route.path === "/cart",
        chip: cart?.cartItems?.length,
        action: () => {
            navigateTo("/cart");
        },
    },
    {
        label: "حساب کاربری",
        icon: "i-solar-user-circle-line-duotone",
        active: route.path === "/user" || route.path.startsWith("/dashboard"),
        action: () => {
            navigateTo("/user");
        },
    },
]);

const activeIndex = computed(() => {
    return useFindIndex(list.value, "active");
});

const ListItemBounding = computed(() => ({
    height: wrapperHeight.value + 16,
    width: wrapperWidth.value / list.value.length,
}));

const topWrapperStyle = computed(() => ({
    "--wrapper-height": ListItemBounding.value.height + "px",
}));

const beforeGapStyle = computed(() => ({
    width: ListItemBounding.value.width * activeIndex.value + (ListItemBounding.value.width - 60) / 2 + "px",
    height: ListItemBounding.value.height + "px",
    borderTopLeftRadius: "33px",
}));

const middleGapStyle = computed(() => ({
    width: "60px",
}));

const afterGapStyle = computed(() => ({
    width:
        ListItemBounding.value.width * (list.value.length - activeIndex.value - 1) +
        (ListItemBounding.value.width - 60) / 2 +
        "px",
    height: ListItemBounding.value.height + "px",
    borderTopRightRadius: "33px",
}));
</script>

<style scoped>
.active-menu-item {
    --size: 45px;
    --shadow-size: 72px;
    @apply relative z-10;
    width: var(--size);
    height: var(--size);
    box-shadow: 0 0 0 4px theme("colors.amazon.500");
}
.active-menu-item::before {
    content: "";
    width: var(--shadow-size);
    height: 150%;
    left: calc(calc(var(--size) - var(--shadow-size)) / 2);
    top: calc(-25 + 5px);
    @apply absolute z-10 bg-transparent rounded-b-full;
    box-shadow: 0 40px 0 0 white;
}

.list-menu-item,
.before-gap,
.middle-gap,
.after-gap {
    @apply transition-all duration-200 ease-in-out;
}
</style>
